import _ from 'lodash';
import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import { toast } from 'react-toastify';
import * as types from './actionTypes';
import { CONTRACT_ADMIN_LEFT_NAV_ITEMS } from '../constants';
import * as urls from './urlTypes';
import { toastError } from '../util/toastUtils';
import {
  cleanupLocationSection,
  isEntDataChanged,
  resetContractSectionToDefault,
} from '../util/ContractAdminUtils';

export const setSupportNav = (parentNav, childNav = '') => dispatch => {
  const activateNav = [];
  const NAV_ITEMS = CONTRACT_ADMIN_LEFT_NAV_ITEMS;
  NAV_ITEMS.map(parent => {
    const isParentActive = parent.name === parentNav;
    let activeChild = childNav;
    if (childNav) {
      activeChild = parent.children.includes(childNav) ? childNav : '';
    }
    const navigation = {
      ...parent,
      active: isParentActive,
      activeChild,
    };

    activateNav.push(navigation);
    return false;
  });

  dispatch({
    type: types.SET_CONTRACT_ADMIN_NAVIGATION,
    navItems: activateNav,
  });
};

export const encodeQueryParams = obj => {
  const sq = cloneDeep(obj);
  return Object.entries(sq)
    .map(e => e.join('='))
    .join('&');
};

export const _getDefinitionData = (data = []) => {
  const uiData = data.map(item => {
    return {
      ...item,
      isActive: false,
    };
  });

  return uiData;
};

export const _getDefinitionResponse = async (accountId, param, cancelToken) => {
  const sq = encodeQueryParams(param);
  let url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/contracts`;
  if (sq) {
    url = `${url}?${sq}`;
  }
  try {
    const response = await axios({
      url,
      method: 'get',
      responseType: 'json',
      cancelToken: cancelToken.token,
      withCredentials: true,
    });
    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return response.data;
    }
    return false;
  } catch (error) {
    // console.log('Api failed to get data enablement target list');
    return false;
  }
};
// export const setSelectedTargets = (isSelected, row, isAll = false) => (
//   dispatch,
//   getState
// ) => {
// };
export const setCATableQuery = query => async dispatch => {
  dispatch({
    type: types.SET_CA_TABLE_QUERY,
    query,
  });
};
let cancelToken;
export const getDeDefinitions = (
  accountId,
  param,
  isLoadMore = false,
  isAllChecked = false
) => async (dispatch, getState) => {
  if (typeof cancelToken != typeof undefined) {
    cancelToken.cancel('Operation canceled due to new request.');
  }
  cancelToken = axios.CancelToken.source();
  const state = getState();
  const CADefinitionStateData = state.contractAdmin.definition.response.data;
  if (!isLoadMore) {
    dispatch({
      type: types.RESET_CA_QUERY_ON_SEARCH_SORT,
    });
    dispatch({
      type: types.GET_CA_DEFINITION_REQUEST,
    });
  }
  const definitionDataResponse = await _getDefinitionResponse(
    accountId,
    param,
    cancelToken
  );
  if (definitionDataResponse && definitionDataResponse.status !== 500) {
    // merge currnet state and new data;
    const formattedDefinitionData = _getDefinitionData(
      definitionDataResponse.data.data
    );
    let data = formattedDefinitionData;
    if (data && definitionDataResponse.data.currentPage > 1) {
      formattedDefinitionData.map(item => {
        item.isChecked = isAllChecked;
        return item;
      });
      data = [...CADefinitionStateData, ...formattedDefinitionData];
    } else {
      data.map(item => {
        item.isChecked = isAllChecked;
        return item;
      });
    }
    const response = {
      data,
      totalPages: definitionDataResponse.data.totalPages,
      currentPage: definitionDataResponse.data.currentPage,
      hasMorePages: definitionDataResponse.data.hasMorePages,
    };

    dispatch({
      type: types.GET_CONTRACT_ADMIN_DEFINITION_SUCCESS,
      response,
    });
  } else {
    dispatch({
      type: types.GET_CONTRACT_ADMIN_DEFINITION_FAILURE,
    });
  }
  dispatch(setCATableQuery(param));
};

export const saveUser = async data => {
  // const url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/contracts/accounts`;
  // const method = 'post';
  let url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/contracts/accounts`;
  let method = 'post';
  if (data.accountId !== '') {
    url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/contracts/account`;
    method = 'put';
  }
  try {
    const response = await axios({
      url,
      method,
      withCredentials: true,
      data,
    });
    return response;
  } catch (error) {
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    return false;
  }
};

export const getUploadedDocId = async formData => {
  try {
    const response = await axios({
      url: `${urls.API_GATEWAY_URL}/api/contracts-admin-service/contracts/documents`,
      method: 'POST',
      timeout: 0,
      processData: false,
      mimeType: 'multipart/form-data',
      contentType: false,
      data: formData,
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    return false;
  }
};
export const setAddNewFlag = add => dispatch => {
  dispatch({
    type: types.SET_ADD_NEW_FLAG,
    value: add,
  });
};
export const setAddNewEntitlement = add => dispatch => {
  dispatch({
    type: types.SET_ADD_NEW_ENTITLEMENT_FLAG,
    value: add,
  });
};
export const setIsSummary = summary => dispatch => {
  dispatch({
    type: types.CA_SUMMARY,
    value: summary,
  });
};
export const setEditEntitlement = edit => dispatch => {
  dispatch({
    type: types.SET_EDIT_ENTITLEMENT_FLAG,
    value: edit,
  });
};
export const setSelectedEntitlementId = id => dispatch => {
  dispatch({
    type: types.SET_ENTITLEMENT_ID,
    value: id,
  });
};

export const getDetailByContractId = Id => {
  const url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/contracts/${Id}`;
  return dispatch =>
    axios({
      url,
      method: 'get',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
    }).then(response => {
      if (response.data.data && response.data.status === 200) {
        const data = response.data.data;
        dispatch({
          type: types.SET_SELECTED_CONTRACT_ID,
          payload: Id,
        });
        dispatch({
          type: types.SET_CONTRACT_EDIT_DATA,
          payload: response.data.data,
        });
        dispatch({
          type: types.SET_SELECTED_LOCATION_ID,
          payload: data.locations[0].locationId,
        });
        return true;
      }
    });
};
export const getUploadedDocuments = item => {
  const url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/contracts/documents/${item.documentId}`;
  if (item.documentId === null) {
    toastError(`Document not uploaded for contract ${item.contractName}`);
  } else {
    return dispatch =>
      axios({
        url,
        method: 'get',
        headers: {
          Accept: 'application/json;charset=UTF-8',
        },
        withCredentials: true,
        responseType: 'json',
        validateStatus: status => status >= 200 && status < 202,
      })
        .then(response => {
          if (response.status === 200 && response.data === null) {
            return response;
          }
        })
        .catch(response => {
          console.log(response);
        });
  }
};
export const resetCreatAccountForm = add => dispatch => {
  dispatch({
    type: types.RESET_ADD_ACCOUNT_FORM,
    value: add,
  });
};

export const updateAccountData = data => dispatch => {
  dispatch({
    type: types.SET_CONTRACT_EDIT_DATA,
    payload: data,
  });
};

export const setUnsavedChangeFlag = flag => dispatch => {
  dispatch({
    type: types.SET_UNSAVED_CHANGE_FLAG,
    payload: flag,
  });
};

export const setEditedAccountData = data => dispatch => {
  dispatch({
    type: types.SET_EDITED_ACCOUNT_DATA,
    payload: data,
  });
};
export const setEntUnsaveChanges = flag => dispatch => {
  dispatch({
    type: types.SET_ENT_UNSAVED_CHANGES_FLAG,
    payload: flag,
  });
};

export const hasEntUnsavedChanges = ref => (dispatch, getState) => {
  let hasChanged = false;
  if (ref.current) {
    const data = ref.current.isAnyDataUpdated;

    if (data) {
      hasChanged = true;
    }
    return hasChanged;
  }
};

export const dataCheck = () => (dispatch, getState) => {
  const contract = resetContractSectionToDefault();
  const location = cleanupLocationSection();
  let hasChanged = false;
  const editedData = getState().contractAdmin.editedAccountData;
  const addAccount = getState().contractAdmin.addAccount;
  if (
    !_.isEqual(editedData, addAccount) ||
    (editedData.locations[''] &&
      !_.isEqual(editedData.locations[''], location)) ||
    (editedData.contracts[''] && !_.isEqual(editedData.contracts[''], contract))
  ) {
    hasChanged = true;
  }
  return hasChanged;
};

export const getSavedEntList = (accountId, Id, loc) => {
  const url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/entitlements/${accountId}/${Id}`;
  return dispatch =>
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data: [loc.locationId],
      validateStatus: status => status >= 200 && status < 202,
    })
      .then(response => {
        if (response.data.data && response.data.status === 200) {
          return response;
        }
      })
      .catch(response => {
        toastError(` Api failed to get data`);
      });
};

export const resetContractId = Id => dispatch => {
  dispatch({
    type: types.SET_SELECTED_CONTRACT_ID,
    value: Id,
  });
};

export const getParentAccountList = async () => {
  let url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/account/parents`;
  try {
    const response = await axios({
      url,
      method: 'get',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      responseType: 'json',
      withCredentials: true,
    });
    if (response.data && response.data.status === 200) {
      return response.data.data;
    }
  } catch (error) {
    toastError(error);
    return false;
  }
};
